import { render, staticRenderFns } from "./DivisionSchema.vue?vue&type=template&id=4952806d&scoped=true"
import script from "./DivisionSchema.vue?vue&type=script&lang=js"
export * from "./DivisionSchema.vue?vue&type=script&lang=js"
import style0 from "./DivisionSchema.vue?vue&type=style&index=0&id=4952806d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4952806d",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Divisions/DivisionSchema.vue
// module id = 2540
// module chunks = 31